module.exports = __webpack_public_path__ + "static/media/341bcc5e-7ac0-44ff-819d-5887892eab1b.7d4ad38c.woff";